import { useState, useMemo } from 'react';
import './PaginationCss.css';

const PaginatedTable = ({ columns, rows }) => {
    const [entriesPerPage, setEntriesPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [filterType, setFilterType] = useState('All');

    // Unique types for the filter dropdown
    const identifierTypes = useMemo(() => {
        const types = new Set(rows.map((row) => row.type));
        return ['All', ...Array.from(types)];
    }, [rows]);

    // Filtered data
    const filteredRows = useMemo(() => {
        return filterType === 'All'
            ? rows
            : rows.filter((row) => row.type === filterType);
    }, [rows, filterType]);

    const totalPages = Math.ceil(filteredRows.length / entriesPerPage);

    const paginatedRows = useMemo(() => {
        const startIdx = (currentPage - 1) * entriesPerPage;
        return filteredRows.slice(startIdx, startIdx + entriesPerPage);
    }, [filteredRows, currentPage, entriesPerPage]);

    const handleEntriesChange = (e) => {
        setEntriesPerPage(Number(e.target.value));
        setCurrentPage(1);
    };

    const handlePageChange = (newPage) => {
        if (newPage >= 1 && newPage <= totalPages) {
            setCurrentPage(newPage);
        }
    };

    return (
        <div>
            {/* Controls */}
            <div className="table-controls">
                <div className="control">
                    <label htmlFor="filter" className='filterLabel'>Filter by Identifier Type : </label>
                    <select id="filter" className="identifierFilters" value={filterType} onChange={(e) => {
                        setFilterType(e.target.value);
                        setCurrentPage(1);
                    }}>
                        {identifierTypes.map((type) => (
                            <option key={type} value={type}>{type}</option>
                        ))}
                    </select>
                </div>
            </div>

            {/* Table */}
            <table className="identifier-table">
                <thead>
                    <tr>
                        {columns.map((col) => (
                            <th key={col.accessor}>{col.Header}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {paginatedRows.length === 0 ? (
                        <tr>
                            <td colSpan={columns.length} style={{ textAlign: 'center', padding: '1rem', fontSize: 18 }}>
                                No records found
                            </td>
                        </tr>
                    ) : (
                        paginatedRows.map((row, idx) => (
                            <tr key={idx} className={idx % 2 === 0 ? 'even' : 'odd'}>
                                {columns.map((col) => (
                                    <td key={col.accessor}>{row[col.accessor] || '-'}</td>
                                ))}
                            </tr>
                        ))
                    )}
                </tbody>
            </table>

            {/* Pagination */}
            {totalPages !== 0 &&
                <div className="pagination">
                    <div className="control">
                        <label htmlFor="entries" className='paginatedTableRowSelection'>Row per page : </label>
                        <select id="entries" style={{ padding: "5px" }} value={entriesPerPage} onChange={handleEntriesChange}>
                            {[...Array(10)].map((_, i) => {
                                const val = (i + 1) * 10;
                                return <option key={val} value={val}>{val}</option>;
                            })}
                        </select>
                    </div>
                    <button className={currentPage === 1 ? 'paginatedTableBtnDisabled' : 'paginatedTableBtn'} onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>
                        Previous
                    </button>
                    <span>Page {currentPage} of {totalPages || 1}</span>
                    <button className={currentPage === totalPages ? 'paginatedTableBtnDisabled' : 'paginatedTableBtn'} onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages || totalPages === 0}>
                        Next
                    </button>
                </div>
            }
        </div>
    );
};

export default PaginatedTable;
